module.exports = __webpack_public_path__ + "img/marketea_logo_2023_blue.a1f7b6dc.svg";